(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog/assets/javascripts/views/message/icon.js') >= 0) return;  svs.modules.push('/components/components/dialog/assets/javascripts/views/message/icon.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

(function (svs) {
  'use strict';

  svs.components.dialog = svs.components.dialog || {};

  var DialogMessageIcon = function (_svs$components$dialo) {
    _inherits(DialogMessageIcon, _svs$components$dialo);

    function DialogMessageIcon(icon) {
      var _this;

      _classCallCheck(this, DialogMessageIcon);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(DialogMessageIcon).call(this));
      _this.log = new svs.core.log.Logger('DialogMessageIcon');

      _this.createIconWrapper(icon);

      return _this;
    }

    _createClass(DialogMessageIcon, [{
      key: "createIconWrapper",
      value: function createIconWrapper(icon) {
        this.el = document.createElement('div');
        this.el.className += 'dialog-icon ';
        this.el.innerHTML = svs.ui.icon.partials.icon({
          icon: icon
        });
      }
    }]);

    return DialogMessageIcon;
  }(svs.components.dialog.PubSub);

  svs.components.dialog.Icon = DialogMessageIcon;
})(svs);
 })(window);